import Axios from "../../api/Axios";
const BASE_URL = "ReceiptsPayments/";
const BASE_URL_Concurrent = "ConcurrentUserLock/";

export const Endpoint = {
    PopulateAllReceiptGrid: "PopulateAllReceiptGrid",
    PopulatePartyData: "PopulatePartyData",
    PopulateMOPData: "PopulateMOPData",
    PopulateAccountsData: "PopulateAccountsData",
    GetCustFinancialInfo: "GetCustFinancialInfo",
    GetReceiptDetail: "GetReceiptDetail",
    AdjustDocument: "AdjustDocument",
    CheckAccoutForPosting: "CheckAccoutForPosting",
    GetReceiptDocDetail: "GetReceiptDocDetail",
    GetReceiptChqDetail: "GetReceiptChqDetail",
    CancelCheck: "CancelCheck",
    ConfirmCancel: "ConfirmCancel",
    PrintReceipt: "PrintReceipt",
    SaveReceipt: "SaveReceipt",
    GetReceiptPQRDetail: "GetReceiptPQRDetail",
    GetPaymentDetail: "Payments/GetPaymentDetail",
    PopulatePaymentAccountsData: "Payments/PopulatePaymentAccountsData",
    GetPaymentDocDetail: "Payments/GetPaymentDocDetail",
    GetPaymentChqDetail: "Payments/GetPaymentChqDetail",
    SavePayment: "Payments/SavePaymentDetails",
    CheckBeforeDelete: "Payments/CheckBeforeDelete",
    PaymentCancellation: "Payments/PaymentCancellation",
    UpdateAfterCancellation: "Payments/UpdateAfterCancellation",
    GetAllPaymentList: "Payments/GetAllPaymentList",
    PopulateCustomer: "Payments/PopulateCustomer",
    OnCustomerSelected: "Payments/OnCustomerSelected",
    GetPaymentBTDetail: "Payments/GetPaymentBTDetail",
    SavePaymentDetails: "Payments/SavePaymentDetails",
    PaymentAdjustDocument: "Payments/AdjustDocument",
    AcquireLock: "AcquireLock",
    ReleaseLock: "ReleaseLock"

};
// /api/ReceiptsPayments/GetReceiptDocDetail
// /api/ReceiptsPayments/ConfirmCancel
// /api/ReceiptsPayments/SaveReceipt
// /api/ReceiptsPayments/PopulateAllReceiptGrid
// /api/ReceiptsPayments/PopulatePartyData
// /api/ReceiptsPayments/PopulateAccountsData
// /api/ReceiptsPayments/GetCustFinancialInfo
// /api/ReceiptsPayments/GetReceiptDetail
// /api/ReceiptsPayments/GetReceiptChqDetail
// /api/ReceiptsPayments/CancelCheck

export const createAPIReceiptsEndpoint = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        getConcurrent: (Endpoint) => Axios.get(BASE_URL_Concurrent + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
        postConcurrent: (Endpoint, data) => Axios.post(BASE_URL_Concurrent + Endpoint, data),
    };
};